/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!****************************************!*\
  !*** ./src/assets/js/video-section.js ***!
  \****************************************/
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VideoSection = /*#__PURE__*/function () {
  function VideoSection() {
    var _this = this;

    _classCallCheck(this, VideoSection);

    _defineProperty(this, "onStartVideo", function (video, section) {
      var videoContainer = section.querySelector(_this.selectors.videoContainer);

      if (videoContainer) {
        videoContainer.classList.add(_this.modificators.playing);
        video.play();
      }
    });

    _defineProperty(this, "onStopVideo", function (video, section) {
      var videoContainer = section.querySelector(_this.selectors.videoContainer);

      if (videoContainer) {
        videoContainer.classList.remove(_this.modificators.playing);
        video.pause();
      }
    });

    _defineProperty(this, "playYoutubeVideo", function (video, section) {
      var videoContainer = section.querySelector(_this.selectors.videoContainer);

      if (videoContainer) {
        videoContainer.classList.add(_this.modificators.playing);
        video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      }
    });

    this.selectors = {
      section: ".video-section",
      videoContainer: ".video-section__video-container",
      playBtn: '.video-play-button',
      placeholder: '.video-placeholder'
    };
    this.modificators = {
      active: "active",
      playing: "playing"
    };
    this.activeVideos = [];
    this.activeSections = null;
  }

  _createClass(VideoSection, [{
    key: "initListeners",
    value: function initListeners(section) {
      var _this2 = this;

      var playBtn = section.querySelector(this.selectors.playBtn);
      var video = section.querySelector('video');
      var iframe = section.querySelector('iframe');
      var videoContainer = section.querySelector(this.selectors.videoContainer);

      if (playBtn) {
        playBtn.addEventListener('click', function () {
          if (video) {
            _this2.onStartVideo(video, section);
          } else if (iframe) {
            _this2.playYoutubeVideo(iframe, section);
          }
        });
      }

      if (video) {
        this.activeVideos.push(video);
        video.addEventListener("play", function () {
          return _this2.onStartVideo(video, section);
        });
        video.addEventListener("pause", function () {
          return _this2.onStopVideo(video, section);
        });
        video.addEventListener('click', function () {
          if (video.controls === false && videoContainer.classList.contains('playing')) {
            _this2.onStopVideo(video, section);
          } else if (video.controls === false && !videoContainer.classList.contains('playing')) {
            _this2.onStartVideo(video, section);
          }
        });
      }

      if (iframe) {
        this.activeVideos.push(iframe);
      }
    }
  }, {
    key: "handleSections",
    value: function handleSections() {
      var _this3 = this;

      var sections = document.querySelectorAll(this.selectors.section);
      sections.forEach(function (section) {
        _this3.initListeners(section);
      });
      this.activeSections = sections;
    }
  }]);

  return VideoSection;
}();

document.addEventListener("DOMContentLoaded", function () {
  if (!window.VideoSections) {
    window.VideoSections = [];
  }

  var videoSections = new VideoSection();
  videoSections.handleSections();
  window.VideoSections.push(videoSections);
});
/******/ })()
;